import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import './index.scss'
import __i18n from "../../../intl/__i18n";
import {getFormattedPrice, getFormattedDate} from '@utils';


function NewUsersChart({data, intl}) {
  const {formatMessage} = intl;
  
  return (
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            text: __i18n("Collective Report")
          },
          subtitle: {
            text: ""
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter: function () {
                return getFormattedDate({date : this.value, showTime: false})
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Amount in {currency}", {currency: __i18n("Toman")})
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px"></span><table>',
            pointFormat: `<tr><td style="color:{series.color};padding:0">${ __i18n("Toman")}: </td>` +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: __i18n("Total Amount"),
            data: data.map(item => [item.date_time, item.sum_amount / 10]),
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(NewUsersChart);

